export interface AnalyticsRequest {
    logEntryType: string,
    interval: string,
    beforeTimestamp: string,
    onOrAfterTimestamp: string,
    recordsDataType?: string,
    user: string
}

export interface AnalyticsResponse {
    "date" : string,
    "count": number
}

export enum  Intervals {
    DAYS = "DAYS",
    MONTHS ="MONTHS",
    YEARS = "YEARS"
}

export enum RecordsDataTypes {
    ALL = "ALL",
    BUSINESS = "BUSINESS",
    MESH = "MESH",
    PANORAMA = "PANORAMA",
    POINT_CLOUD = "POINT_CLOUD",
    RASTER = "RASTER",
    VECTOR = "VECTOR",
    UNKNOWN = "UNKNOWN"
}
